/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Solo_DescInputs */

const en_cp_p_solo_desc = /** @type {(inputs: Cp_P_Solo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter at −30 % with a campus email (.ac.id): 5 PRDs, 60 messages, 10 Sol credits per month. Voucher sent after verification through the form.`)
};

const id_cp_p_solo_desc = /** @type {(inputs: Cp_P_Solo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter −30 % dengan email kampus (.ac.id): 5 PRD, 60 pesan, 10 kredit Sol per bulan. Voucher dikirim setelah verifikasi lewat formulir.`)
};

/**
* | output |
* | --- |
* | "Starter at −30 % with a campus email (.ac.id): 5 PRDs, 60 messages, 10 Sol credits per month. Voucher sent after verification through the form." |
*
* @param {Cp_P_Solo_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_solo_desc = /** @type {((inputs?: Cp_P_Solo_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Solo_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_solo_desc(inputs)
	return en_cp_p_solo_desc(inputs)
});